import { VERIFY_ACCOUNT_REQUEST, VERIFY_ACCOUNT_SUCCESS, VERIFY_ACCOUNT_FAILURE } from '../../constants/account.constants';

export const verifyAccountRequest = token => ({
    type: VERIFY_ACCOUNT_REQUEST, token,
});

export const verifyAccountRequestSuccess = () => ({
    type: VERIFY_ACCOUNT_SUCCESS,
});

export const verifyAccountRequestFailure = error => ({
    type: VERIFY_ACCOUNT_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/App/redux/actions/account_actions/verify_account.actions.js